import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import moment from 'moment';

const TabletAppField: React.FC = () => {
	const { latestSoftwareUpdateData } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	const inputValue = latestSoftwareUpdateData?.tabletAppAssignedDate
		? `${moment(latestSoftwareUpdateData.tabletAppAssignedDate).format('MM/DD/YYYY h:mm:ss A')} ${
				latestSoftwareUpdateData.lastTabletAppVersionName
		  }`
		: undefined;

	return <FullInfoField label="tabletAppLabel" value={inputValue} />;
};

export default TabletAppField;
